<template>
  <div id="nav">
    <AppLink id="logo" :to="{ name: 'Home' }">Vue School Travel App</AppLink>
    <AppLink
      v-for="destination in destinations"
      :key="destination.id"
      :to="{
        name: 'DestinationDetails',
        params: { id: destination.id, slug: destination.slug },
      }"
    >
      {{ destination.name }}
    </AppLink>
    <AppLink to="/user">Dashboard</AppLink>
    <AppLink to="https://vueschool.io">Vue School</AppLink>
  </div>
</template>
<script>
import sourceData from "@/data.json";
export default {
  computed: {
    destinations() {
      return sourceData.destinations;
    },
  },
};
</script>
